import firebase from "../firebase/firebase";
import {
  UPLOAD_ICON_LOADING,
  UPLOAD_ICON_SUCCESS,
  UPLOAD_ICON_FAIL,
  DELETE_ICON_LOADING,
  DELETE_ICON_SUCCESS,
  DELETE_ICON_FAIL,
  FETCH_ICON_FAIL,
  SET_ICON
} from './types';

export const uploadMapIcons = ({ icon, name, eventId }) => async (dispatch) => {
  try {
    dispatch({ type: UPLOAD_ICON_LOADING });
    await firebase.storage().ref(`custom_map_icons/${eventId}/${name}`).putString(icon, 'data_url');
    dispatch({ type: UPLOAD_ICON_SUCCESS });
  } catch (e) {
    dispatch({ type: UPLOAD_ICON_FAIL });
  }
}

export const deleteMapIcons = ({ name, eventId }) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_ICON_LOADING });
    await firebase.storage().ref(`custom_map_icons/${eventId}/${name}`).delete();
    dispatch({ type: DELETE_ICON_SUCCESS, payload: name });
  } catch (e) {
    dispatch({ type: DELETE_ICON_FAIL });
  }
}

export const getCustomMapIcons = (eventId) => async (dispatch) => {
  try {
    const seekcityvisitedRef = firebase.storage().ref(`custom_map_icons/${eventId}/seekcityvisited`);
    
    seekcityvisitedRef.getDownloadURL()
      .then(url => dispatch(setIcon({
        prop: 'seekcityvisited',
        icon: url
      })))
      .catch(e => dispatch({ type: FETCH_ICON_FAIL }))

    const seekcityRef = firebase.storage().ref(`custom_map_icons/${eventId}/seekcity`);
    
    seekcityRef.getDownloadURL()
    .then(url => dispatch(setIcon({
      prop: 'seekcity',
      icon: url
    })))
    .catch(e => dispatch({ type: FETCH_ICON_FAIL }));
  } catch (e) {
    console.log(e);
  }
}

export const setIcon = ({ icon, prop }) => ({
    type: SET_ICON,
    payload: {
      prop,
      icon
    },
  })
